import styled, { css } from 'styled-components'

import {
  type CatalogItemTagVariant,
  CatalogItemTagVariants,
} from '../CatalogItemTagVariants'

export const CatalogItemTagLayoutStyled = styled.div<{
  $variant: CatalogItemTagVariant
}>`
  display: inline-flex;
  align-items: center;
  gap: ${(props) => props.theme.space.xsmall};
  padding: ${(props) =>
    `${props.theme.typography.pxToRem(4)} ${props.theme.space.small}`};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};

  ${(props) => {
    switch (props.$variant) {
      case CatalogItemTagVariants.SUCCESS:
        return css`
          background: ${props.theme.colors.badge.success.background};
          color: ${props.theme.colors.badge.success.content};
        `
      case CatalogItemTagVariants.WARNING:
        return css`
          background: ${props.theme.colors.badge.warning.background};
          color: ${props.theme.colors.badge.warning.content};
        `
      default:
        return css`
          border: ${props.theme.typography.pxToRem(1)} solid
            ${props.theme.colors.badge.neutral.border};
          background: ${props.theme.colors.badge.neutral.background};
          color: ${props.theme.colors.badge.neutral.content};
        `
    }
  }}
`
